export const billingAccessRoutes = ["/payments", "/clinic-pet-details"];
export const inventoryAccessRoutes = ["/inventory"];
export const groomerAccessRoutes = ["/groomdashboard", "/groom-pet-details"];
export const labAccessRoutes = ["/labdashboard", "/lab-pet-details"];
export const pharmacyAccessRoutes = [
  "/phramacydashboard",
  "/pharmacy-pet-details",
];
